import * as R from 'ramda';
import { createSelector } from 'reselect';

export default createSelector(
  R.path(['Rations', 'ui', 'isFixed']),

  R.identity,
);
